<template>
  <div class="pa-park-finder-selector">
    <ul class="pa-selector">
      <li v-for="menu in menus" :key="menu.slug" :class="menu.class">
        <router-link :to="menu.to"><span>{{menu.label}}</span></router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed : {
    viewType(){
      return this.$route.params.viewType;
    }
  },

  watch : {
    viewType : {
      handler(value){
        switch(value){
          case 'finder':
            this.menus.finder.class['is-active'] = true;
            this.menus.clips.class['is-active'] = false;
          break;

          case 'clips':
            this.menus.finder.class['is-active'] = false;
            this.menus.clips.class['is-active'] = true;
          break;
        }
      },
      immediate: true
    }
  },

  data(){
    return {
      menus : {
        finder  : {
          slug  : 'finder',
          label : 'ひろばを探す',
          class : {
            'is-active' : true
          },
          to    : {
            name    : 'parks.view',
            params  : {
              viewType  : 'finder',
            }
          }
        },
        
        clips   : {
          slug  : 'clips',
          label : 'ひろば帳',
          class : {
            'is-active' : false
          },
          to    : {
            name    : 'parks.view',
            params  : {
              viewType  : 'clips',
            }
          }
        }
      }
    };
  }
}
</script>

<style lang="scss">
.pa-park-finder-selector{
  ul.pa-selector{
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    li{
      box-sizing: border-box;
      width:48%;
      text-align: center;
      font-size:1.3rem;
      
      background-color: #C2A78F;
      color:#7C5E49;
      border-radius: 4px;

      a{
        display: block;
        padding:.3rem;
        width:100%;
        color:#7C5E49;
      }

      &.is-active{
        background-color: #B3957C;
      }
    }
  }
}
</style>